import { Box, Button, Stack, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { usePortfolioItemColor } from "web_myplann/Portfolio/Hooks/usePortfolioItemColor";
import type { PortfolioItemColor } from "web_myplann/Portfolio/Types/PortfolioAddItemTypes";

type Props = {
	icon: LucideIcon;
	label: string;
	color: PortfolioItemColor;
	onClick: () => void;
};

export const PortfolioAddItemCategoryTile: FC<Props> = ({
	icon: Icon,
	label,
	color,
	onClick,
}) => {
	const theme = useTheme();
	const { icon: iconColor, surface: surfaceColor } =
		usePortfolioItemColor(color);

	return (
		<Button
			variant="tile"
			onClick={onClick}
			startIcon={
				<Stack
					alignItems="center"
					justifyContent="center"
					sx={{
						width: 32,
						height: 32,
						borderRadius: "50%",
						bgcolor: surfaceColor,
						flexShrink: 0,
					}}
				>
					<Icon size={theme.iconSize.sm} color={iconColor} />
				</Stack>
			}
		>
			<Box
				component="span"
				sx={{
					display: "-webkit-box",
					WebkitLineClamp: 2,
					WebkitBoxOrient: "vertical",
					overflow: "hidden",
					textOverflow: "ellipsis",
					minWidth: 0,
				}}
			>
				{label}
			</Box>
		</Button>
	);
};
